import { AosSeverity } from '../../common/types/AosSeverity'
import { TaskCategory } from './TaskCategory'
import { TaskProcessType } from './TaskProcessType'

export type TaskTemplatesFilters = {
    category: TaskCategory[]
    processType: TaskProcessType[]
    severity: AosSeverity[]
    assigneeId: string[]
    templateName?: string
    page: number
    size: number
    siteLocation: string
}

export const initialTaskTemplatesFilters: TaskTemplatesFilters = {
    category: [],
    processType: [],
    severity: [],
    assigneeId: [],
    templateName: '',
    page: 0,
    size: 10,
    siteLocation: '',
}
